import {cubicBezier} from '@local/utils/maths'
import {cx} from '@local/utils/cx'
import {CSSProperties, useRef} from 'react'

export interface SplitWordstProps {
	children?;
	isActive?: boolean;
	stagger?: number;
	duration?: number;
}

const STAGGER = 0.015
const DURATION = 1.5

export const SplitWords = ({children, isActive, stagger = STAGGER, duration = DURATION}: SplitWordstProps) => {
	const textArr = useRef(children.split(' ')).current
	const charArrLength = useRef(children.replace(/\s/g, '').split('').length).current
	let charCount = useRef(0).current

	return (
		<>
			{textArr.map((word, idx) => (
				<span
					aria-label={word}
					className={cx(
						'inline whitespace-break-spaces',
						'[&>span]:inline [&>span]:transition-opacity [&>span]:ease-quad-inout [&>span]:will-change-[opacity]',
					)}
					key={idx}>
					{word.split('').map((char, innerIndex) => {
						charCount++
						const _easing = cubicBezier(charCount / charArrLength, 0.83, 0, 0.17, 1)
						const transitionDelay = _easing * charArrLength * stagger
						return (
							<span
								key={`${idx}-${innerIndex}`}
								style={{
									transitionDuration: `${duration}s`,
									transitionDelay: `${transitionDelay}s`,
								} as CSSProperties}
								className={cx(
									'splitTextChar',
									isActive ? 'opacity-100' : 'opacity-40',
								)}>
								{char}
							</span>
						)
					})}
					{idx !== textArr.length - 1 && <span> </span>}
				</span>
			))}
		</>
	)
}
